import { AnnotationsRequestTypes } from './types';
import { AnnotationsActions } from './actions';
import { combineReducers } from '@fullstory/redux-util';
import { AppBackendActions } from '../appbackend';
import { SpaceActions } from '../spaces';
import { annotationsAdapter } from './adapters';
import { createAccessReducer } from '../../utils';

export type AnnotationsState = ReturnType<typeof annotationsAdapter.createInitialState>;

export const annotations = (
  state: AnnotationsState = annotationsAdapter.createInitialState(),
  action: AppBackendActions | AnnotationsActions | SpaceActions,
) => {
  switch (action.type) {
    case AnnotationsRequestTypes.GetGlobalAnnotationsSuccess:
    case AnnotationsRequestTypes.GetAnnotationsForDxObjectSuccess: {
      const { annotations } = action.data;
      return annotations ? annotationsAdapter.setMany(state, annotations) : state;
    }
    case AnnotationsRequestTypes.CreateAnnotationSuccess: {
      const { annotation } = action.data;
      return annotation ? annotationsAdapter.addOne(state, annotation) : state;
    }
    case AnnotationsRequestTypes.DeleteAnnotationAndAssociationSuccess: {
      return annotationsAdapter.removeOne(state, action.data.id);
    }
    case AnnotationsRequestTypes.UpdateAnnotationSuccess: {
      const { annotation } = action.data;
      return annotation ? annotationsAdapter.setOne(state, annotation) : state;
    }
    default:
      return state;
  }
};

const access = createAccessReducer(
  AnnotationsRequestTypes.GetAnnotationsAccessRequest,
  AnnotationsRequestTypes.GetAnnotationsAccessSuccess,
  AnnotationsRequestTypes.GetAnnotationsAccessFailure,
);

export type AnnotationsReducerState = {
  annotations: ReturnType<typeof annotations>;
  access: ReturnType<typeof access>;
};

export const annotationsReducer = combineReducers<AnnotationsReducerState>({
  annotations,
  access,
});
